module.exports = __webpack_public_path__ + "assets/img/25_368_big.554a3c00.jpg";